import { useQuery } from '@tanstack/react-query';
import { queryClient as globalQueryClient } from 'src/store/store';
import useProjectSystem from '../systems/useProjectSystem';
import { QueryKeys } from './queryKeys';
import { DEFAULT_QUERY_OPTIONS } from './constants';
import useFetchCurrentUserQuery from '../../authentication/queries/useFetchCurrentUserQuery';

const useFetchProjectCountsQuery = () => {
	const system = useProjectSystem();
	const { data: currentUser } = useFetchCurrentUserQuery();
	const enabled = !!currentUser;

	return useQuery(
		QueryKeys.forProjectCounts(),
		() => system.fetchProjectCounts(),
		{
			...DEFAULT_QUERY_OPTIONS,
			enabled
		}
	);
};

export const invalidateProjectCountsQuery = () => {
	globalQueryClient.invalidateQueries( {
		queryKey: QueryKeys.forProjectCounts(),
		refetchType: 'active'
	} );
}

export default useFetchProjectCountsQuery;
